// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2p8Ym","text":"SelectPayment_text__1jM4K","title":"SelectPayment_title__2ksJ1","btn":"SelectPayment_btn__10cGG"};